// Moonlauncher's only fee, for static copy (hero, /fees, FAQ, JSON-LD).
// Must equal LAUNCH_FEE_LAMPORTS in src/core/fees.ts; tests/fees-copy.test.ts
// checks they match.
export const LAUNCH_FEE_SOL = "0.01";
